import { AsyncPipe, NgClass, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TooltipModule } from "primeng-v17/tooltip";
import { map } from "rxjs";
import { DocumentTemplateStatusIcons } from "../../document-template/document-templates.model";
import { MessageService } from "../message.service";

@Component({
  selector: "app-message-success",
  templateUrl: "./message-success.component.html",
  styleUrl: "./message-success.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgClass, TooltipModule, AsyncPipe],
  host: {
    "(mouseenter)": "onMouseEnter()",
    "(mouseleave)": "onMouseLeave()",
  },
})
export class MessageSuccessComponent {
  readonly message$ = this.messageService.message$.pipe(
    map((x) => (!x || x.severity === "success" || x.severity === "warning" ? x : null))
  );

  readonly Icons = {
    success: DocumentTemplateStatusIcons.Success,
    warning: DocumentTemplateStatusIcons.Warning,
  };

  constructor(private readonly messageService: MessageService) {}

  onMouseEnter(): void {
    this.messageService.pause();
  }

  onMouseLeave(): void {
    this.messageService.resume();
  }
}
